<script>
  import { filterMenu, toggleFilterMenu } from './stores/filter-store.js';
  import { productCount } from './stores/collection-products-store.js';
  import Icon from './Icon.svelte';
  import CollectionSort from './CollectionSort.svelte';
</script>

<header>
  <div class="lg:hidden grid grid-cols-1 xs:grid-cols-2 gap-s-mobile">
    <button class="btn btn--solid flex justify-between items-center bg-lighter-grey border-lighter-grey text-brand-blue w-full" on:click={toggleFilterMenu}>
      <span>Filter</span>
      
      <Icon icon="filter" h={12} w={16} classes="" />
    </button>

    <CollectionSort device="mobile" />
  </div>

  <div class="hidden lg:grid lg:grid-cols-collection gap-4xl lg:gap-l xl:gap-4xl">
      <div class="border-b border-brand-blue text-brand-blue flex justify-between items-center pb-1.5">
        <button
          class="font-body font-medium stretch-semi-expanded text-b2 flex items-center uppercase"
          on:click={toggleFilterMenu}
        >
          <Icon icon="filter" h={15} w={20} classes="mr-1" />
          {$filterMenu ? 'Filter By' : 'Show Filters'}
        </button>

        {#if $filterMenu}
          <button class="btn text-b2 font-body font-normal flex items-center text-accent-blue" on:click={toggleFilterMenu}>
            <span class="mr-1">Close</span>
            <Icon icon="close" h={12} w={12} />
          </button>
        {/if}
      </div>

      <div class="border-b border-brand-blue text-brand-blue flex justify-between pb-1.5">
        <p class="font-body font-medium stretch-semi-expanded text-b2 uppercase">({$productCount}) Products</p>

        <span class="btn text-b2 font-body font-normal flex items-center">
          <p class="mr-1 cursor-auto">Sort By</p>
          <CollectionSort device="desktop" />
        </span>
      </div>
  </div>
</header>
